<template>
  <div class="register">
    <van-nav-bar
      class="head"
      :title="type==0?'注册':'忘记密码'"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="register-con">
      <img v-if="type==0" class="img" src="./imgs/register.png" alt="注册">
      <img v-if="type==1" class="img" src="./imgs/forget.png" alt="忘记密码">
      <div class="content">
        <van-form validate-first @failed="onFailed" @submit="onSubmit">
          <van-field
            v-model="email"
            name="email"
            placeholder="请输入邮箱"
            :rules="[{ pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, message: '邮箱格式有误，请重试' }]"
          />
          <div class="codeBox">
            <van-field
              class="itemContent"
              v-model="validateCode"
              name="validateCode"
              placeholder="请输入验证码"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
            </van-field>
            <div
              class="btn"
              :class="{ active: sendOk }"
              @click="getCode"
            >
              <span v-if="!sendOk">获取验证码</span>
              <span v-else> {{ time }}s后重发</span>
            </div>
          </div>
          <van-field
            v-model="password"
            type="password"
            name="password"
            placeholder="请输入密码"
            :rules="[{ pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/, message: '密码应为8-16位，包含大小写字母、数字' }]"
          />
          <van-field
            v-model="confirmPassword"
            type="password"
            name="confirmPassword"
            placeholder="二次确认密码"
            :rules="[{ pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/, message: '密码应为8-16位，包含大小写字母、数字' }]"
          />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">{{type==0?'注册':'确认修改 '}}</van-button>
          </div>
          <div class="togo">
            <span> * 密码为8-16位，包含大小写字母、数字</span>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getEmailCode, registerUser, updatePassword, forgetPwdEmailCode, checkoutForgetPwdEmailCode } from '@/api/user';
export default {
  name: 'register',
  data() {
    return {
      type: '',
      sendOk: false,
      email: '',
      password: '',
      validateCode: '',
      confirmPassword: '',
      time: 60,
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type == 0) {
      window.document.title = '注册'
    } else {
      window.document.title = '忘记密码'
    }
  },
  methods: {
    onClickLeft() {
      window.history.back(-1)
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
      this.$toast(errorInfo.errors[0].message);
    },
    onSubmit(values) {
      let { email, password, confirmPassword, validateCode } = values;
      if (password != confirmPassword) {
        return this.$toast('两次输入的密码不一致');
      }
      if (this.type == 0) { // 注册
        registerUser({
          'email': email, // 电子邮箱，比如 example@qq.com
          'password': password, // 密码
          'validateCode': validateCode, // 邮箱验证码
        }).then((res) => {
          if (res.data.code == 200) {
            this.$toast(res.data.message);
            setTimeout(() => {
              this.$router.push({
                path: '/user/login',
              });
            }, 1000);
          } else {
            this.$toast(res.data.message);
          }
        });
      } else { // 忘记密码
        checkoutForgetPwdEmailCode({
          'email': email,
          'code': validateCode,
        }).then((res) => {
          if (res.data.code == 200) {
            updatePassword({
              'email': email, // 电子邮箱，比如 example@qq.com
              'password': password, // 密码
            }).then((res) => {
              if (res.data.code == 200) {
                this.$toast(res.data.message);
                setTimeout(() => {
                  this.$router.push({
                    path: '/user/login',
                  });
                }, 1000);
              } else {
                this.$toast(res.data.message);
              }
            });
          } else {
            this.$toast(res.data.message);
          }
        });
      }
    },
    countDown() {
      setTimeout(() => {
        if (this.time != 1) {
          this.countDown();
        } else {
          this.sendOk = false;
          this.time = 60;
        }
        this.time = this.time -1
      },1000);
    },
    getCode() {
      if (!this.email) {
        this.$toast('请输入邮箱号');
        return;
      }
      if (this.sendOk) {
        return;
      }
      if (this.type == 0) {
        getEmailCode({
          email: this.email,
        }).then((res) => {
          if (res.data.code == 200) {
            this.sendOk = true;
            this.countDown();
            this.$toast('验证码已发送邮箱');
          } else {
            this.$toast(res.data.message);
          }
        })
      } else {
        forgetPwdEmailCode({
          email: this.email,
        }).then((res)=> {
          if (res.data.code == 200) {
            this.sendOk = true;
            this.countDown();
            this.$toast('验证码已发送邮箱');
          } else {
            this.$toast(res.data.message);
          }
        });
      }
    },
  },
  mounted() {
  },
  updated(){
  },
};
</script>

<style scoped lang="scss">
.register{
  height: 100%;
  box-sizing: border-box;
  padding-top: 50px;
  .head{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    margin-top: -50px;
    text-align: center;
    background: #fff;
  }
  ::v-deep .van-nav-bar .van-icon{
    color: #333;
  }
  .register-con{
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
    .img{
      position: absolute;
      top: 0;
      width: 100%;
      height: 160px;
    }
    .content{
      position: absolute;
      width: 90%;
      height: 70%;
      margin-top: 110px;
      background: #FFFFFF;
      box-shadow: 0px 10px 40px 0px rgba(223, 223, 223, 0.91);
      border-radius: 16px;
      ::v-deep .van-cell::after{
        display: none;
      }
      ::v-deep .van-form{
        padding: 24px 20px;
        .van-field__control{
          height: 45px;
          border-radius: 22px;
          padding: 0 17px;
          background: #F8F8F8;
        }
        .van-button{
          height: 45px;
          border-radius: 22px;
          background: linear-gradient(90deg, #3790FF, #376BFF);
          box-shadow: 0px 20px 14px 0px rgba(102, 174, 228, 0.18);
        }
        .van-cell{
          padding-top: 5px;
        }
        .van-cell::after{
          display: none;
        }
      }
      .codeBox{
        position: relative;
        .btn{
          position: absolute;
          top: 22px;
          right: 30px;
          font-size: 14px;
          line-height: 14px;
          font-weight: 400;
          color: #376BFF;
          border-left: 1px solid #376BFF;
          padding-left: 10px;
        }
      }
      .togo{
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        a,span{
          color: #999999;
          line-height: 10px;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
